import { Chip } from '@vnetwork/ui/primitives';
import { StatusPill } from '@vnetwork/ui/data';
import { DetailHeader } from '@/components/detail-header';
import type { CustomerDetail } from '@/api/customers';
import { customerTone, humanize } from './status-tones';
import { leadTypeLabel } from './label-maps';

/**
 * Detail identity header: breadcrumb back-to-list, then the customer id prefix,
 * name, status StatusPill, and lead-type Chip. Delegated to the shared
 * `DetailHeader` frame so all detail pages render a consistent identity block.
 */
export function CustomerDetailHeader({ detail }: { detail: CustomerDetail }) {
  return (
    <DetailHeader
      parent={{ label: 'Customers', to: '/customers' }}
      current={detail.customer_name}
      idPrefix={`#${detail.customer_id}`}
      title={detail.customer_name}
      meta={
        <>
          <StatusPill tone={customerTone(detail.customer_status)}>
            {humanize(detail.customer_status)}
          </StatusPill>
          {detail.customer_lead_type ? (
            <Chip appearance="subtle" tone="neutral">
              {leadTypeLabel(detail.customer_lead_type)}
            </Chip>
          ) : null}
        </>
      }
    />
  );
}
